import CreateJD from "../../createJD";

export default function NuJobsCreateJD(props) {
  return (
    <div className="nujobspostedjds-wrapper">
       <CreateJD nujobsPost = {true}/>
    </div>  
  );
}
